import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { Loader2, Phone, Mail, MapPin, Clock } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PageHero } from "./Services";

export default function Contact() {
  const { data: content } = useQuery({ queryKey: ["content"], queryFn: () => api.get("/content").then(r => r.data.content) });
  const info = content?.contact_info || {};
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/contact", form); toast.success("Message sent! We'll be in touch."); setForm({ name: "", email: "", phone: "", message: "" }); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  const input = "w-full h-11 px-3 rounded-lg border border-input bg-white focus:outline-none focus:ring-2 focus:ring-electric text-sm";
  return (
    <div>
      <PageHero label="Contact" title="Let's talk" subtitle="Questions, callbacks, or just want to chat about a project? Reach out." />
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14 grid md:grid-cols-2 gap-10">
        <div className="space-y-4">
          {[[Phone, "Phone", info.phone], [Mail, "Email", info.email], [MapPin, "Service Area", info.area], [Clock, "Hours", info.hours]].map(([Ico, label, val], i) => (
            <div key={i} className="flex gap-3 rounded-xl border border-slate-200 p-5">
              <div className="h-10 w-10 rounded-lg bg-electric/10 text-electric grid place-items-center shrink-0"><Ico className="h-5 w-5" /></div>
              <div><p className="text-xs font-mono uppercase tracking-wider text-metallic">{label}</p><p className="font-medium text-navy">{val}</p></div>
            </div>
          ))}
        </div>
        <form onSubmit={submit} data-testid="contact-form" className="space-y-4 rounded-2xl border border-slate-200 p-6">
          <label className="block"><span className="block text-sm font-medium text-navy mb-1.5">Name *</span><input required className={input} value={form.name} onChange={e => set("name", e.target.value)} data-testid="contact-name" /></label>
          <label className="block"><span className="block text-sm font-medium text-navy mb-1.5">Email *</span><input required type="email" className={input} value={form.email} onChange={e => set("email", e.target.value)} data-testid="contact-email" /></label>
          <label className="block"><span className="block text-sm font-medium text-navy mb-1.5">Phone</span><input className={input} value={form.phone} onChange={e => set("phone", e.target.value)} data-testid="contact-phone" /></label>
          <label className="block"><span className="block text-sm font-medium text-navy mb-1.5">Message *</span><textarea required rows={5} className={`${input} h-auto py-2`} value={form.message} onChange={e => set("message", e.target.value)} data-testid="contact-message" /></label>
          <Button type="submit" disabled={loading} className="w-full bg-electric hover:bg-tech" data-testid="contact-submit">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send Message"}</Button>
        </form>
      </section>
    </div>
  );
}
